export class Country {
    constructor(public code: string, public name: string) {}
}
